<mat-card class="cur-card" formGroupName="supplyresumptionResultInfo">
    <mat-card-content>

        <div *ngIf="sagyoshubetsuCD == '2'; then generalResumptionSupply; else simplifiedResumptionSupply"></div>

        <!-- 一般供給再開 -->
        <ng-template #generalResumptionSupply>
            <div class="tw-flex tw-flex-row tw-flex-wrap" style="margin-bottom: 20px;">
                <mat-radio-group color="warn" class="search-condition-radio-frame"
                    (change)="onChangeActionWitness($event.value)" formControlName="supplyresumptionTaiperDivcd"
                    style="width:400px">
                    <mat-label class="mat-label-ragiogroup">立会人</mat-label>
                    <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                        *ngFor="let code of codeMap?.get('S300842')">{{code.hyojiCont}}</mat-radio-button>

                    <mat-checkbox class="check-box" color="primary" id="witnessNotnoticeFlg"
                        [disabled]="getControl('witnessNotnoticeFlg').disabled" [checked]="witnessNotnoticeFlg"
                        (change)="witnessNotnoticeFlg = $event.checked" style="margin-left: 50px;">周知不可
                    </mat-checkbox>
                </mat-radio-group>
            </div>
        </ng-template>

        <!-- 簡易供給再開 -->
        <ng-template #simplifiedResumptionSupply>
            <div class="tw-flex tw-flex-row tw-flex-wrap" style="margin-bottom: 20px;">
                <mat-radio-group color="warn" class="search-condition-radio-frame"
                    (change)="onChangePlaceWork($event.value)" formControlName="workPlaceCode"
                    class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[170px] tw-max-w-[170px] tw-min-w-[170px]">
                    <mat-label class="mat-label-ragiogroup"> 作業場所</mat-label>
                    <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                        *ngFor="let code of codeMap?.get('S300800')">{{code.hyojiCont}}</mat-radio-button>
                </mat-radio-group>
            </div>

            <div fclass="tw-flex tw-flex-row tw-flex-wrap" style="margin-bottom: 20px;" *ngIf="miconViewFlg">
                <mat-radio-group color="warn" class="search-condition-radio-frame"
                    (change)="onChangeMicomMeter($event.value)" formControlName="microcontrollermeterUmuFlg"
                    class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[340px] tw-max-w-[340px] tw-min-w-[340px]">
                    <mat-label class="mat-label-ragiogroup"> マイコンメーター</mat-label>
                    <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                        *ngFor="let code of codeMap?.get('S301270')">{{code.hyojiCont}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-template>

        <div class="tw-flex tw-flex-row tw-flex-wrap">
            <mat-form-field appearance="outline"
                class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                <mat-label>作業メモ</mat-label>
                <textarea matInput style="resize: none;width: 100%;" rows="10" maxlength="500"
                    formControlName="sgyshMemo"></textarea>
            </mat-form-field>
        </div>
        <div style="margin-top: 100px;"></div>

    </mat-card-content>
</mat-card>